import {CommonModule} from "@angular/common";
import {Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output} from "@angular/core";
import {MatButtonModule} from "@angular/material/button";
import {Router, RouterModule} from "@angular/router";
import {Store} from "@ngrx/store";
import {TranslateModule} from "@ngx-translate/core";
import {PanelModule} from "primeng/panel";
import {Observable} from "rxjs";
import {RouteId} from "app/enums/env/routes-id-enum";
import {iconClass} from "app/enums/icon-class.enum";
import {MainRoute} from "app/models/MainRoute";
import {RoutingService} from "app/services/Routing.service";
import {FeatureState, selectFeatureStateForm} from "app/store";
import {AuthService} from "app/tinea-components/okta/auth/auth.service";
import {LoggedInService} from "app/tinea-components/okta/services/loggedIn.service";
import {UserSessionService} from "app/tinea-components/okta/services/session/user-session.service";
import {NavigationItemComponent} from "./navigation-item/navigation-item.component";
import {QuickAccessPanelComponent} from "./quick-access-panel/quick-access-panel.component";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {TooltipModule} from "primeng/tooltip";
import {AuthentWithCustomOktaService} from "app/tinea-components/okta/auth/services/authent-with-custom-okta.service";
import {LoggedInAuthentService} from "app/tinea-components/okta/services/loggedInAuthentservice";
import {environment} from "environments/environment";
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Component({
  selector: "app-navigation",
  templateUrl: "./navigation.component.html",
  styleUrls: ["./navigation.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    PanelModule,
    MatButtonModule,
    RouterModule,
    TranslateModule,
    NavigationItemComponent,
    QuickAccessPanelComponent,
    TooltipModule
  ],
  providers: [
    { provide: AuthService, useClass: AuthentWithCustomOktaService },
    { provide: LoggedInService, useClass: LoggedInAuthentService }
  ],
  animations: [
    trigger('fadeInOut', [
      state('hidden', style({ opacity: 0, transform: 'translateX(-10px)' })),
      state('visible', style({ opacity: 1, transform: 'translateX(0)' })),
      transition('hidden => visible', [
        animate('300ms ease-out')
      ]),
      transition('visible => hidden', [
        animate('200ms ease-in')
      ])
    ])
  ]
})
export class NavigationComponent implements OnInit {
  @Input() isExpanded = true;
  @Input() isLoggedIn = true;

  @Output() menuToggleChange = new EventEmitter<void>();

  public toggleFeatureSelect$: Observable<FeatureState>;

  public iconClass = iconClass;
  public logo = environment.core.logoPath;
  public routes: MainRoute[] = [];
  public adminRoute!: MainRoute;
  public routeId = RouteId;

  private readonly userSessionService = inject(UserSessionService);
  private readonly destroyRef = inject(DestroyRef);

  private readonly currentUser$ = this.userSessionService.currentUser$;

  constructor(
    public router: Router,
    public authService: AuthService,
    private routingService: RoutingService,
    private readonly store: Store
  ) {
    this.toggleFeatureSelect$ = this.store.select(selectFeatureStateForm);
  }

  ngOnInit() {
    this.initializeMenu();
  }

  initializeMenu() {
    this.currentUser$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(user => {
        if (user && user.uid) {
          this.setMenu();
        }
      })
  }

  setMenu() {
    const allRoutes = [...this.routingService.getRoutesLeftMenu()];
    this.routes = allRoutes.filter(
      (route) => route.id !== RouteId.ADMINISTRATION
    );
    this.adminRoute =
      (allRoutes.find(
        (route) => route.id === RouteId.ADMINISTRATION
      ) as MainRoute) || null;
  }

}
